// بيانات تجريبية بالعربية - Solid Consulting

export const companyInfo = {
  name: "Solid Consulting",
  tagline: "هندسة متينة. تأثير حقيقي.",
  description: "شريك استشارات تقنية متقدم يقدم حلول موثوقة ومركزة على النتائج.",
  email: "contact@solidconsulting.fr",
  phone: "+33 6 35 63 97 43",
  address: "44 av de lattre de tassigny, Marcq-en-Barœul 59700, France"
};

export const navigation = [
  { name: "الخدمات", href: "/services" },
  { name: "دراسات الحالة", href: "/case-studies" },
  { name: "من نحن", href: "/about" },
  { name: "المدونة", href: "/blog" },
  { name: "اتصل بنا", href: "/contact" }
];

export const services = [
  {
    id: "web-development",
    title: "تطوير الويب",
    shortDescription: "تطبيقات SPA حديثة، بوابات، لوحات معلومات بأحدث الأطر.",
    description: "نبني تطبيقات ويب عالية الأداء تحقق نتائج. من لوحات المعلومات المعقدة إلى المنصات الموجهة للعملاء.",
    technologies: ["React", "Angular", "Vue.js", "Next.js", "TypeScript"],
    missions: ["تطوير SPA", "إنشاء بوابات المؤسسات", "لوحات معلومات وقت حقيقي", "منصات B2B/B2C", "تطبيقات PWA"],
    outcomes: ["سرعة تحميل +50%", "تفاعل محسّن", "معدل ارتداد منخفض", "تجربة سلسة"]
  },
  {
    id: "mobile-development",
    title: "تطوير الموبايل",
    shortDescription: "تطبيقات موبايل أصلية ومتعددة المنصات لـ iOS و Android.",
    description: "نصنع تطبيقات موبايل يحبها المستخدمون مع تركيز على الأداء والأمان.",
    technologies: ["React Native", "Flutter", "Swift", "Kotlin", "iOS", "Android"],
    missions: ["تطوير iOS/Android أصلي", "تطبيقات متعددة المنصات", "تحديث تطبيقات", "تحسين App Store", "تكامل backend"],
    outcomes: ["تقييم 4.5+", "تكاليف منخفضة", "وصول أسرع للسوق", "UX متسق"]
  },
  {
    id: "backend-apis",
    title: "الواجهة الخلفية وواجهات البرمجة",
    shortDescription: "هندسة خدمات مصغرة وتطوير API-first مع Java و Spring Boot.",
    description: "نصمم أنظمة خلفية قابلة للتوسع. نهج API-first يضمن المرونة والصيانة.",
    technologies: ["Java", "Spring Boot", "Node.js", "NestJS", "REST", "GraphQL"],
    missions: ["تصميم microservices", "تطوير REST/GraphQL", "تحديث أنظمة قديمة", "API gateway", "Event-driven"],
    outcomes: ["99.9% وقت تشغيل", "استجابة <100ms", "تكاملات مبسطة", "دين تقني منخفض"]
  },
  {
    id: "cloud-devops",
    title: "السحابة وDevOps",
    shortDescription: "خبرة AWS و Azure مع CI/CD، serverless، Kubernetes.",
    description: "نساعد المؤسسات على تبني السحابة بثقة. بنية مرنة وآمنة ومُحسّنة التكلفة.",
    technologies: ["AWS", "Azure", "Kubernetes", "Docker", "Terraform", "CI/CD"],
    missions: ["هجرة السحابة", "تنفيذ CI/CD", "Kubernetes", "Serverless", "IaC"],
    outcomes: ["تقليل 60% وقت النشر", "موثوقية محسّنة", "تكاليف محسّنة", "نشر بدون توقف"]
  },
  {
    id: "consulting-architecture",
    title: "الاستشارات والهندسة",
    shortDescription: "توجيه استراتيجي حول API-first، السحابة، التدقيق، التدريب.",
    description: "إرشادات خبيرة للقرارات التقنية الصحيحة. من مراجعة الهندسة إلى تدريب الفرق.",
    technologies: ["تصميم الهندسة", "التدقيق التقني", "تدريب الفرق", "أفضل الممارسات"],
    missions: ["تصميم هندسة تقنية", "تدقيق كود", "استشارة API-first", "تطوير مهارات", "خارطة طريق"],
    outcomes: ["خارطة واضحة", "مخاطر منخفضة", "سرعة محسّنة", "هندسة مستدامة"]
  }
];

export const caseStudies = [
  {
    id: "fintech-platform",
    title: "منصة التداول المالي",
    client: "بنك أوروبي رائد",
    industry: "المالية",
    context: "بنك أوروبي احتاج تحديث منصة التداول للتعامل مع الأحجام المتزايدة.",
    challenge: "النظام القديم لم يستطع التوسع مما سبب تأخير وشكاوى.",
    solution: "هندسة microservices مع Spring Boot و Kubernetes. معالجة بيانات وقت حقيقي عبر Kafka.",
    techStack: ["Java", "Spring Boot", "Kubernetes", "Kafka", "React", "PostgreSQL", "AWS"],
    results: [
      { metric: "الإنتاجية", value: "x10" },
      { metric: "تقليل التأخير", value: "85%" },
      { metric: "وقت التشغيل", value: "99.99%" },
      { metric: "الامتثال", value: "100%" }
    ]
  },
  {
    id: "retail-ecommerce",
    title: "منصة التجزئة متعددة القنوات",
    client: "سلسلة تجزئة عالمية",
    industry: "التجزئة",
    context: "سلسلة عالمية مع 500+ متجر احتاجت منصة موحدة.",
    challenge: "أنظمة منفصلة أدت لتناقضات مخزون وتجربة مجزأة.",
    solution: "منصة API-first مع مزامنة وقت حقيقي وملفات عملاء موحدة.",
    techStack: ["Node.js", "NestJS", "React Native", "GraphQL", "MongoDB", "Azure", "Redis"],
    results: [
      { metric: "الإيرادات", value: "+45%" },
      { metric: "دقة المخزون", value: "99.5%" },
      { metric: "رضا العملاء", value: "+35 NPS" },
      { metric: "التنفيذ", value: "أسرع 2x" }
    ]
  },
  {
    id: "industrial-iot",
    title: "منصة IoT صناعية",
    client: "شركة تصنيع",
    industry: "الصناعة",
    context: "شركة مع 20 مصنعاً احتاجت رؤية وقت حقيقي للمعدات.",
    challenge: "أنظمة قديمة قدمت بيانات متأخرة مما سبب أعطال غير متوقعة.",
    solution: "منصة IoT سحابية على AWS مع edge computing و ML للصيانة التنبؤية.",
    techStack: ["Python", "AWS IoT", "Lambda", "React", "TensorFlow", "TimescaleDB", "Grafana"],
    results: [
      { metric: "تقليل التوقف", value: "70%" },
      { metric: "تكاليف الصيانة", value: "-40%" },
      { metric: "التأخير", value: "<1 ثانية" },
      { metric: "الكفاءة", value: "+25%" }
    ]
  },
  {
    id: "saas-platform",
    title: "توسيع منصة SaaS",
    client: "شركة SaaS ناشئة",
    industry: "SaaS",
    context: "شركة ناشئة احتاجت التوسع من 100 إلى 10,000+ عميل.",
    challenge: "الهندسة لم تتعامل مع multi-tenancy. استعلامات DB أصبحت عنق زجاجة.",
    solution: "إعادة هندسة مع multi-tenancy، sharding DB، وpipeline CI/CD قوي.",
    techStack: ["Node.js", "React", "PostgreSQL", "Kubernetes", "GitHub Actions", "Datadog"],
    results: [
      { metric: "السعة", value: "x100" },
      { metric: "الأداء", value: "x10 أسرع" },
      { metric: "النشر", value: "يومي" },
      { metric: "الاستجابة", value: "<5 دقائق" }
    ]
  }
];

export const benefits = [
  { title: "خبرة متقدمة", description: "10+ سنوات خبرة. لا مبتدئين." },
  { title: "التركيز على التسليم", description: "برمجيات تعمل. معالم واضحة." },
  { title: "عقلية API-First", description: "أنظمة للتكامل والتوسع." },
  { title: "Cloud Native", description: "حلول مرنة وعالمية." }
];

export const workProcess = [
  { step: 1, title: "اكتشف", description: "نتعمق في سياق عملك وأهدافك." },
  { step: 2, title: "صمم", description: "نصمم حلول توازن بين الابتكار والواقعية." },
  { step: 3, title: "ابنِ", description: "تطوير تكراري مع تسليم في دورات قصيرة." },
  { step: 4, title: "شغّل", description: "تسليم سلس، توثيق، ودعم طويل المدى." }
];

export const industries = [
  { name: "المالية", icon: "building" },
  { name: "التجزئة", icon: "shopping-cart" },
  { name: "الصناعة", icon: "factory" },
  { name: "SaaS", icon: "cloud" },
  { name: "الرعاية الصحية", icon: "heart-pulse" },
  { name: "اللوجستيات", icon: "truck" }
];

export const aboutValues = [
  { title: "الجودة", description: "لا اختصارات. الصيانة طويلة المدى أولوية." },
  { title: "الشفافية", description: "تواصل واضح، تقييمات صادقة، تحديثات منتظمة." },
  { title: "الملكية", description: "نتعامل مع مشروعك كمشروعنا." },
  { title: "التعلم المستمر", description: "تعلم مستمر ومشاركة معرفة." }
];

export const aboutStory = {
  title: "قصتنا",
  content: `تأسست Solid Consulting في 2024 من قبل مهندسين متقدمين أصابهم الإحباط من الوضع الراهن. كثيراً ما رأينا مشاريع يُوظف فيها مستشارون غير متمرسين.

آمنا بأن هناك طريقة أفضل. شركة توظف فقط المواهب المتقدمة. شريك يركز على القيمة الحقيقية.

اليوم، أكثر من 10 مستشارين متقدمين يخدمون عملاء في أوروبا وأفريقيا. 95% احتفاظ، عشرات المشاريع المُسلّمة، سمعة في التميز.

نحن لسنا الأكبر — نحن من تتصل به عندما تحتاج أن يُنجز بشكل صحيح.`
};

export const blogPosts = [
  { id: "api-first-design", title: "تصميم API-First: لماذا هو مهم", summary: "كيف يسرّع API-first التطوير.", category: "الهندسة", readTime: "8 دقائق", date: "2025-07-15" },
  { id: "microservices-pitfalls", title: "5 أخطاء شائعة في Microservices", summary: "أخطاء الفرق وكيفية تجنبها.", category: "DevOps", readTime: "12 دقيقة", date: "2025-06-28" },
  { id: "cloud-cost-optimization", title: "تحسين تكاليف السحابة", summary: "تقليل AWS/Azure 30-50%.", category: "السحابة", readTime: "10 دقائق", date: "2025-06-10" },
  { id: "spring-boot-best-practices", title: "Spring Boot في الإنتاج", summary: "أنماط لتطبيقات قوية.", category: "Backend", readTime: "15 دقيقة", date: "2025-05-22" },
  { id: "kubernetes-migration", title: "هجرة Kubernetes خطوة بخطوة", summary: "الهجرة دون تعطيل العمليات.", category: "DevOps", readTime: "14 دقيقة", date: "2025-05-05" }
];

export const faqs = [
  { question: "مع أي شركات تعملون؟", answer: "Scale-ups، متوسطة، كبيرة. مالية، تجزئة، صحة، SaaS." },
  { question: "كيف تضمنون الجودة؟", answer: "8+ سنوات خبرة. عملية فحص صارمة. لا مبتدئين." },
  { question: "نماذج التعاقد؟", answer: "وقت ومواد، سعر ثابت، فرق مخصصة حسب الحاجة." },
  { question: "العمل مع فريقنا؟", answer: "نعم. نتكامل، نعزز، نوجه حسب الحاجة." },
  { question: "نهج إدارة المشاريع؟", answer: "أجايل لكن براغماتي. تكرارات قصيرة، شفافية." }
];

export const contactFormFields = [
  { name: "name", label: "الاسم الكامل", type: "text", required: true },
  { name: "company", label: "الشركة", type: "text", required: true },
  { name: "email", label: "البريد الإلكتروني", type: "email", required: true },
  { name: "projectType", label: "نوع المشروع", type: "select", required: true, options: ["تطوير الويب", "تطوير الموبايل", "Backend & APIs", "Cloud & DevOps", "الاستشارات", "أخرى"] },
  { name: "budget", label: "الميزانية", type: "select", required: false, options: ["< 50,000$", "50,000$ - 150,000$", "150,000$ - 500,000$", "> 500,000$", "غير محدد"] },
  { name: "message", label: "أخبرنا عن مشروعك", type: "textarea", required: true }
];

